export default {
  es: {
    stageTitle: 'Mi estadío actual',
    kidneyProgressTitle: 'Evolución de mi enfermedad renal',
    bloodPressureTitle: 'Mi tensión arterial',
    bloodGlucoseTitle: 'Control de mi diabetes',
    nutritionalTitle: 'Mi estado nutricional',
    adherenceTitle: 'Asistencia a mis controles',
    myEvents: 'Mis eventos'
  },
  en: {
    stageTitle: 'My current stage',
    kidneyProgressTitle: 'My kidney progress',
    bloodPressureTitle: 'My blood pressure',
    bloodGlucoseTitle: 'My blood glucose control',
    nutritionalTitle: 'My nutritional status',
    adherenceTitle: 'My adherence',
    myEvents: 'My eventos'
  }
};
